import React, { useCallback } from 'react';

import ConfirmDialog from 'components/confirm-dialog';
import { useProductWizardContext } from 'pages/menu/components/product-wizard';
import { ProductWizardStep } from 'pages/menu/components/product-wizard/types';
import { useProductWizardFlow } from 'pages/menu/components/product-wizard/use-product-wizard-flow';
import { t } from 'state/intl/translations';

import { BodyComponent } from '../body-component';

export const UnsavedChangesDialog = () => {
  const { goToPreviousStep, currentFlowStep } = useProductWizardFlow();

  const {
    showCloseDialog,
    setShowCloseDialog,
    restoreSlotsSelectionSnapshot,
    clearSlotsSelectionSnapshot,
  } = useProductWizardContext();

  const shouldShowDialog =
    showCloseDialog && currentFlowStep.step === ProductWizardStep.ProductCustomization;

  const heading = t('unsavedChangesModalHeader');
  const content = t('unsavedChangesModalDescription');

  const saveLabel = t('saveChanges');
  const discardLabel = t('leaveWithoutSaving');

  const onConfirm = useCallback(() => {
    setShowCloseDialog(false);
    clearSlotsSelectionSnapshot();
    goToPreviousStep();
  }, [goToPreviousStep, setShowCloseDialog, clearSlotsSelectionSnapshot]);

  const onCancel = useCallback(() => {
    restoreSlotsSelectionSnapshot();
    setShowCloseDialog(false);
    goToPreviousStep();
  }, [setShowCloseDialog, goToPreviousStep, restoreSlotsSelectionSnapshot]);

  return (
    <ConfirmDialog
      showDialog={shouldShowDialog}
      modalAppearanceEventMessage="Confirmation: Product Wizard - Discard Unsaved Changes"
      bodyComponent={<BodyComponent heading={heading} content={content} />}
      confirmLabel={saveLabel}
      cancelLabel={discardLabel}
      onConfirm={onConfirm}
      onCancel={onCancel}
    />
  );
};
